import { useCallback } from 'react';

import { useGraphql } from '../graphql';

// Saves a clinician's note on one answer of a submitted test, or on the
// whole test when position is null; an empty note removes it. clinicianId is
// the account the note was written under, which the service checks against
// whoever the browser's cookie now belongs to (#132). Settles once saved or
// rejects with its sentence.
export function useNoteChanges() {
  const graphql = useGraphql();

  return useCallback(function({ clinicianId, attemptId, position, note }) {
    if (position == null) {
      return graphql({
        document: 'mutation ReviewNote($attemptId: ID!, $note: String!, $clinicianId: ID!) { saveReviewNote(attemptId: $attemptId, note: $note, clinicianId: $clinicianId) }',
        variables: { attemptId, note, clinicianId }
      });
    }

    return graphql({
      document: 'mutation AnswerNote($attemptId: ID!, $position: Int!, $note: String!, $clinicianId: ID!) { saveAnswerNote(attemptId: $attemptId, position: $position, note: $note, clinicianId: $clinicianId) }',
      variables: { attemptId, position, note, clinicianId }
    });
  }, [ graphql ]);
}
